if typeof window.RedactorPlugins == 'undefined'
  window.RedactorPlugins = {}
RedactorPlugins.counter = {
  init: ->
    # find / set counter
    if @$box.next(".wordCount").find(".count").length
      @$counter = @$box.next(".wordCount").find(".count")
    else
      @$counter = @$box.parent().next(".wordCount").find(".count")
    @limit = @$box.find('[data-limit]').data('limit')
    @setCounter()

    @$editor.on 'keydown.counter', (e) =>
      key = e.keyCode || e.which
      ctrl = e.ctrlKey || e.metaKey
      unless @count() < @limit || key in [8,37,38,39,40] || ctrl
        e.preventDefault()

    @$editor.on 'keyup.counter', (e) =>
      if @count() > @limit
        @set($.truncate(@get(), length: @limit, ellipsis:''))
      @setCounter()

  setCounter: ->
    @$counter.text(@limit - @count())

  count: ->
    text = @$editor.html()
    text = text.replace(/<inline.*<\/inline>/, '')
    text = text.replace(/&nbsp;/gi, ' ')
    text = text.replace(/<\/?[a-z](?:[^>"']|"[^"]*"|'[^']*')*>/gi, '')
    text = text.replace(/\t/gi, '')
    text = text.replace(/\n/gi, ' ')
    text = text.replace(/\r/gi, ' ')
    text = $.trim(text)
    text.length
}
